import request from '@/utils/request';

const path = 'api/v1';

const userLogin = data => request({
  url: `${path}/login`,
  method: 'POST',
  data,
});

const userLogout = () => request({
  url: `${path}/logout`,
  method: 'DELETE',
});

const userInfoGet = data => request({
  url: `${path}/user/0`,
  method: 'GET',
  params: data,
});

export {
  userLogin,
  userLogout,
  userInfoGet,
};
